import {activateAccount} from "@awe-web/shared/lib";
import {B2C_SignUpConfirmed, B2C_SelectStationAndTime} from "../../../routing/routes.js";

export const initialize = (activationToken, rentContractToken) => async (dispatch, getState, context) => {
  if (!activationToken) {
    return B2C_SelectStationAndTime.path();
  }
  try {
    await dispatch(activateAccount(activationToken, rentContractToken));
    return B2C_SignUpConfirmed.path();
  }
  catch (error) {
    console.error(error);
    return B2C_SelectStationAndTime.path();
  }
};
